import { Component, Input, OnInit } from '@angular/core';

import { SmartModalService } from 'app/core/services/smart-modal.service';

@Component({
    selector: 'itpx-reject-payment',
    templateUrl: './reject-payment.component.html',
    styleUrls: ['./reject-payment.component.css']
})
export class RejectPaymentComponent implements OnInit {

    @Input() data: any = null;

    approvalDetails: any = null;
    rejectionMessage: any = null;

    constructor(
        private smartModalService: SmartModalService
    ) { }

    ngOnInit(): void {
        this.approvalDetails = this.data.pendingApproval;
    }

    submit() {
        this.smartModalService.sendResult(this.rejectionMessage);
    }

    cancel() {
        this.smartModalService.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/transacion-aprovals/reject-payment/reject-payment.component.ts